// Shipment Status Constants
// see: app/models/shipment.rb, enum: status
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const SHIPMENT_STATUSES = [
  'waiting',
  'shipped',
  'in_transit',
  'arrived_at_hub',
  'arrived_at_destination',
  'received',
  'returned',
  'returned_to_sender',
  'problem',
] as const

export type ShipmentStatus = typeof SHIPMENT_STATUSES[number]

export function useShipmentStatusLabel() {
  const { t } = useTranslation()
  // useCallback：保持回傳函式參照穩定。否則每次 render 都回新函式，
  // 會讓依賴它的 useMemo（如 OrderList 的 baseColumns / 篩選選項）每次重算 → 整頁無窮 re-render。
  return useCallback((status: string | undefined | null): string => {
    if (!status) return ''
    switch (status as ShipmentStatus) {
      case 'waiting':                return t('enums.shipment.status.waiting')
      case 'shipped':                return t('enums.shipment.status.shipped')
      case 'in_transit':             return t('enums.shipment.status.in_transit')
      case 'arrived_at_hub':         return t('enums.shipment.status.arrived_at_hub')
      case 'arrived_at_destination': return t('enums.shipment.status.arrived_at_destination')
      case 'received':               return t('enums.shipment.status.received')
      case 'returned':               return t('enums.shipment.status.returned')
      case 'returned_to_sender':     return t('enums.shipment.status.returned_to_sender')
      case 'problem':                return t('enums.shipment.status.problem')
      default:                       return status
    }
  }, [t])
}
